module.exports = __webpack_public_path__ + "img/invitation-step-3.c05ab5d7.svg";